<script setup lang="ts">
    import { useStandingAnteversionPromptViewModel } from '@/views/3d-planner/hipSpine/useStandingAnteversionPromptViewModel';

    const promptVm = useStandingAnteversionPromptViewModel();
</script>

<template>
    <app-modal width="716" :model-value="promptVm.isPromptOpen" :persistent="true">
        <v-card class="prompt-card text-center pt-8 pb-8" style="border-radius: 36px">
            <app-modal-title> Update Combined Anteversion </app-modal-title>

            <app-modal-content>
                <v-avatar
                    class="mb-5"
                    size="73"
                    :style="{ backgroundColor: 'rgba(var(--v-theme-primary), 0.36)' }"
                >
                    <v-icon icon="mdi-information-outline" color="main-blue" size="36" />
                </v-avatar>

                <p class="text-body-1 text-secondary-text">
                    The patient's pelvis in supine differs from standing.
                </p>
                <p class="text-body-1 text-secondary-text px-10" width>
                    Update the combined anteversion recommendation to be based on standing or keep
                    as Supine.
                </p>
            </app-modal-content>

            <app-modal-actions class="justify-center ga-4 py-8">
                <app-button
                    color="primary"
                    variant="outlined"
                    width="170"
                    @click="promptVm.keepSupine"
                >
                    Keep Supine
                </app-button>
                <app-button-primary width="200" @click="promptVm.updateToStanding">
                    Update to Standing
                </app-button-primary>
            </app-modal-actions>
        </v-card>
    </app-modal>
</template>

<style scoped lang="scss">
    // Centre the title across the full card, matching the approved design.
    // Values use theme tokens — no raw colours.
    .prompt-card :deep(.v-card-item) {
        justify-content: center;
    }

    .prompt-card :deep(.v-card-item__content) {
        flex: 0 1 auto;
        text-align: center;
    }

    .prompt-card :deep(.v-card-item h3) {
        color: rgb(var(--v-theme-on-surface));
        // AppModalTitle ships the heading at weight 400; the design wants it bold.
        font-weight: 700;
    }
</style>
